<template>
	<div class="settleAccount">
		<div class="content-box">
			<div class="nav df">
				<div class="tou"></div>
				<div class="df-d df-c">
					<p class="font34 mCf">未完成</p>
					<p class="font22 mCf">加油，继续练习下去吧</p>
				</div>
			</div>
			<div class="defen font26 mCf df-sb df-a">
				<div>
					<p class="font42">95</p>
					<p class="">得分</p>
				</div>
				<div class="df-mc df-d">
					<p><span class="font42">6</span> 分 <span class="font42">56</span> 秒</p>
					<p>本次用时</p>
				</div>
			</div>
			<div class="pingfen">
				<div class="caidai">
					
				</div>
				<div class="xinBox df-c">
					<van-icon name="star" color="#FF9000" size="0.83rem" style="position: relative; top: 0.15rem;transform: rotate(-15deg);" />
					<van-icon name="star" color="#E6E6E6" size="0.83rem" style="margin: 0 0.5rem;" />
					<van-icon name="star" color="#E6E6E6" size="0.83rem" style="position: relative; top: 0.15rem;transform: rotate(15deg);"/>
				</div>
				<div class="title font34 tac">
					没关系，可以继续通关！
				</div>
				<div class="font26 mCG tac">点击「改错通关」或「再做一遍」</div>
				<div class="bntBox">
					<div class="zaizuo font32 mCf df-mc">
						再做一遍
					</div>
				</div>
			</div>
			<div class="footer df-sb">
				<div class="bnt df-mc mCf font32">返回</div>
				<div class="bnt df-mc mCf font32">下一单元</div>
			</div>
		</div>
		<div class="xuancuangguan df-a" v-if="isxuan">
			<div class="conetn">
				<van-icon name="cross" size="22" style="position: absolute;right: 0.5rem;top: 0.35rem;" />
				<div class="title tac font30">
					闯关方式选择
				</div>
				<div class="text font28">你可以选择【再做一遍】以巩固知识也可以选择【改错通关】来纠正错误你想通关的方式是?</div>
				<div class="bntBox font30 mCf df-sb">
					<div class="bnt df-mc">
						再做一遍
					</div>
					<div class="bnt df-mc">
						改错通关
					</div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'textBook',
	watch: {},
	data() {
		return {
			title: this.$route.query.name || '人教版-七年级上册',
			icon3: require('../../assets/img/study/icon-3.png'),
			icon4: require('../../assets/img/study/icon-4.png'),
			icon5: require('../../assets/img/study/icon-5.png'),
			icon6: require('../../assets/img/study/icon-6.png'),
			icon7: require('../../assets/img/study/icon-7.png'),
			icon8: require('../../assets/img/study/icon-8.png'),
			ifdaan: false,
			dataList: [{}],
			isxuan:false,
		};
	},
	created() {},
	methods: {
		getNavClass() {
			this.$api
				.getNavClass({
					navid: this.currentId
				})
				.then((res) => {
					let resData = res.data?.data || [];
					this.allRequest = resData.length;

					for (let i = 0; i < resData.length; i++) {
						this.$api
							.getCourseTypeContall({
								coursetypeid: resData[i].id
							})
							.then((res) => {
								this.acount = ++this.acount;
								resData[i].children = res.data || [];
							});
					}

					this.dataList = resData;
				});
		},
		goPage(item) {
			let path = item.name != '同步课堂' ? '/topicLibrary' : '/textContent';
			this.$router.push({
				path: path,
				query: {
					name: '同步课堂',
					type: 0,
					id: 55337,
					istong: 0
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.settleAccount {
	height: 100vh;
	padding: 0rem 0.43rem 0 0.43rem;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	overflow: auto;
	background: #fff;
	background: url('../../assets/img/study/icon-13.png')no-repeat;
	background-size: 100%;
	
	.content-box {
		.nav{
			margin-top: 1.7rem;
			.tou{
				width: 1.16rem;
				height: 1.16rem;
				background: #FFFFFF;
				border-radius: 50%;
				margin: 0 0.24rem 0 0.05rem;
			}
		}
		.defen{
			font-family: Impact;
			margin-top: 0.43rem;
			height: 1.31rem;
			background: #FFAD81;
			border-radius: 0.2rem;
			padding: 0 1.1rem;
		}
		.pingfen{
			margin-top: 0.23rem;
			height: 4.72rem;
			background: #FFFFFF;
			border-radius: 0.2rem;
			padding-top: 0.56rem;
			position: relative;
			.caidai{
				width: 6.84rem;
				height: 7rem;
				background: url('../../assets/img/study/icon-12.png')no-repeat;
				background-size: 100%;
				position: absolute;
				left: -0.2rem;
				top: 0;
			}
			.title{
				color: #FF7A32;
				margin: 0.4rem 0 0.6rem 0;
			}
			.bntBox{
				position: absolute;
				left: 0;
				bottom: 0;
				width: 100%;
				height: 1.24rem;
				background: url('../../assets/img/study/icon-14.png')no-repeat;
				background-size: 100%;
				background-position: bottom left;
				padding: 0 0.4rem;
				z-index: 22;
				.zaizuo{
					height: 0.88rem;
					background: #FF7A32;
					box-shadow: 0px 2px 4px 0px rgba(255,122,50,0.17);
					border-radius: 0.44rem;
					border: 2px solid #FFFFFF;
				}
			}
			
		}
		.footer {
			width: 100%;
			height: 0.98rem;
			position: fixed;
			left: 0;
			right: 0;
			bottom: 0;
			padding: 0 0.43rem;
			.bnt {
				width: calc(50% - 0.13rem);
				height: 0.8rem;
				background: #FFFFFF;
				border: 1px solid #FF7A32;
				color: #FF7A32;
				border-radius: 0.4rem;
			}
		}
		
	}
	.xuancuangguan{
		width: 100%;
		height: 100vh;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		z-index: 33;
		padding: 0 0.85rem;
		background-color: rgba(0,0,0,0.5);
		.conetn{
			height: 4.14rem;
			background: #FFFFFF;
			border-radius: 0.3rem;
			padding: 0.36rem 0.5rem;
			position: relative;
			.text{
				padding: 0.4rem 0 0.3rem 0;
			}
			.bntBox{
				.bnt{
					width: calc(50% - 0.13rem);
					height:0.8rem;
					background: #6B9BDB;
					border-radius: 0.4rem;
				}
			}
		}
	}
}
</style>
